import React, { useState } from 'react';

const ImageBoard = ({ imageUrl, markers, onAddMarker, selectedMarkerId, setSelectedMarkerId, boardRef }) => {
  const [isHovering, setIsHovering] = useState(false);

  const handleClick = (e) => {
    if (e.target.closest('.marker-element')) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    onAddMarker(x, y);
  };

  return (
    <div 
      className="relative shadow-2xl ring-1 ring-black/5 bg-white inline-block max-w-full rounded-lg overflow-hidden"
      style={{ cursor: 'crosshair' }}
    >
      <div 
        ref={boardRef} 
        className="relative inline-block bg-white"
        onClick={handleClick}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {/* Important: crossOrigin="anonymous" and using DataURL/Base64 ensures export works */}
        <img 
          src={imageUrl} 
          alt="Screenshot" 
          crossOrigin="anonymous"
          className="max-w-full h-auto block"
          style={{ maxHeight: '80vh', objectFit: 'contain' }}
        />
        
        {markers.map((marker) => (
          <div
            key={marker.id}
            className={`marker-element absolute w-8 h-8 -ml-4 -mt-4 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg transition-all duration-200 cursor-pointer
              ${selectedMarkerId === marker.id ? 'bg-blue-600 scale-125 ring-4 ring-white' : 'bg-blue-500 hover:bg-blue-600 hover:scale-110'}
            `}
            style={{ 
              left: `${marker.x}%`, 
              top: `${marker.y}%`,
              zIndex: selectedMarkerId === marker.id ? 50 : 10
            }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedMarkerId(marker.id);
            }}
          >
            {marker.number}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageBoard;